<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:country.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:country.country') })"
          icon="edit"
          @updateTableData="updateTable"
          @clickedButton1="editCountry"
          @clickedAddButton="editCountry"
          :addBtn="true"
          sortBy="name"
        />

      </v-col>
    </v-row>

    <CountryForm
      @updateTable="updateAfterSave"
      ref="countryForm" />

  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import CountryService from '@/modules/settings/services/country-service';
import CountryForm from '@/modules/settings/views/settings/country/CountryForm';
import Country from '@/modules/settings/data/country';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';

export default {
  name: "CountryOverview",
  components: {
    DataTablePaginated,
    CountryForm
  },
  data() {
    return {
      country: new Country
    };
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('settings/settings:country.alpha2'), value: 'alpha2'},
        {text: this.$t('settings/settings:country.alpha3'), value: 'alpha3'},
        {text: this.$t('settings/settings:country.timezone'), value: 'timezone'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      CountryService.readAllCountriesPaginated(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Country);
          this.$refs.table.fillTableData(response.data);
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:country.country-table')}));
        }
      );
    },
    editCountry(country) {
      this.$refs.countryForm.initialization(country);
    },
    updateAfterSave() {
      this.$refs.table.callTableUpdate();
    }
  }
}
</script>